export class ConfirmEmailMessage {
  token: string
  id: string
  
  constructor(token: string, id: string) {
    this.token = token
    this.id = id
  }
}
  